import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actionCreator, {
  actionForFullUrls,
} from "../../../redux/action/actionCreator";

// core-components
// import CreationForm from "../Form/Wizard";
import Toast from "../../../components/MessageToast";
import GalleryFormVideo from "../../components/forms/galleryFormVideo";
import { UPLOAD_VIDEO, UPDATE_VIDEO } from "../../../redux/gallery/videos/types";
// import { FETCH_CLIENTS } from "../../../redux/clients/types";
import Loading from "../../../components/isLoading";
import { toast } from "react-toastify";
import BreadCrumps from "../../../components/BreadCrups";
import { fetchVideoData } from "../../../redux/gallery/actions";

export default (props) => {
  const { videoId } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const operationStore = useSelector((store) =>
    videoId ? store.updateImageGlobalStore : store.uploadImageGlobalStore
  );

  const videoData = useSelector((state) => state.videoGlobalStore);

  const openToast = ({ message, type, onClose }) =>
    Toast({ message, type, duration: 3000, onClose });

  const [formState, setFormState] = useState({
    openToast: false,
    currentStep: 1,
    articleId: null,
    articleInfo: {},
  });

  useEffect(() => {
    if (videoId) {
      dispatch(fetchVideoData(videoId));
    }
  }, []);

  const handleFormSubmit = async (formData) => {
    const { title, category, videoUrl, thumbnail } = formData;
    const imageInfo = {
      title,
      category,
      videoUrl,
      thumbnail: thumbnail === "" ? videoUrl : thumbnail,
    };
    await toast.promise(
      dispatch(
        actionCreator({
          method: videoId ? "PATCH" : "POST",
          path: videoId ? `/api/gallery/videos/${videoId}` : `/api/gallery/videos`,
          actionType: videoId ? UPDATE_VIDEO : UPLOAD_VIDEO,
          data: imageInfo,
        })
      ),
      {
        pending: `${!videoId ? "Uploading" : "Updating"} a Video`,
        success: operationStore.message,
        error: `Unable to ${!videoId ? "Create" : "Update"} Video`,
      }
    );
    navigate("/gallery")
  };

  const crumps = [
    {
      title: "Gallery",
      path: "/gallery",
    },
  ];

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {videoId && videoData?.loading ? (
        <Loading />
      ) : (
        <div>
          <GalleryFormVideo
            isCreate={videoId ? false : true}
            onSubmit={handleFormSubmit}
            openToast={openToast}
            baseGalleryData={videoData?.data || {}}
            isLoading={operationStore?.loading}
          />
        </div>
      )}
    </div>
  );
};
